import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface OtpLogsState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}

const otpLogsInitialState: OtpLogsState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getOtpList: any = createAsyncThunk(
  "otp/get",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.OTP_HISTORY, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);



const otpLogsSlice = createSlice({
  name: "Otp List",
  initialState: otpLogsInitialState,
  reducers: {
    resetOtpState: (state) => {
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOtpList.pending, (state) => {
        state.loading = "pending";
        state.action = "list";
        state.error = null;
      })
      .addCase(getOtpList.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.action = "list";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getOtpList.rejected, (state, action) => {
        state.loading = "rejected";
        state.action = "list";
        state.error = action.payload as string;
        state.data = null;
      })


  },
});

export const { resetOtpState } = otpLogsSlice.actions;
export default otpLogsSlice.reducer;
